<template>
  <div class="simple-list-container flex-box column" v-if="itemData">
    <div class="tr tr-head flex-box">
      <div class="td noto-semibold blue">{{itemData.definitions}}</div>
      <div
        class="td noto-semibold blue"
        v-for="title in itemData.columnTitles"
        :key="title.key"
      >{{title}}</div>
    </div>
    <div class="tr flex-box" v-for="(columnTtl, index) in itemData.rowTitles" :key="index">
      <div class="td noto-semibold">{{columnTtl}}</div>
      <div class="td" v-for="data in itemData.data[index]" :key="data.key">{{data}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemData'],
};
</script>
